import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMoreHorComponent } from "./med-icon-more-hor.component";

@NgModule({
  declarations: [
    MedIconMoreHorComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMoreHorComponent,
  ],
})
export class MedIconMoreHorModule { }
